<template lang="pug">
  .photo-instructions
    .text-center
      SectionTitle Photo Instructions

    ul.instruction-list
      li.instruction.xs-f-small.sm-f-medium.max-at-tweak(v-for="(text, index) in instructions" :key="index") {{ text }}

    .examples.xs-12
      .dos.xs-12.md-6
        p.xs-f-small.sm-f-medium.max-at-tweak.color-slate.text-center DOs
        .xs-6
          .a-box-xs-1x1
            .a-box-content
              ImgBox(media-id="6457")
        .xs-6
          .a-box-xs-1x1
            .a-box-content
              ImgBox(media-id="6458")

      .donts.xs-12.md-6
        p.xs-f-small.sm-f-medium.max-at-tweak.color-slate.text-center DON'Ts
        .xs-6
          .a-box-xs-1x1
            .a-box-content
              ImgBox(media-id="6459")

        .xs-6
          .a-box-xs-1x1
            .a-box-content
              ImgBox(media-id="6460")

    .footer.text-center
      button.mr-btn.btn-inverse.xs-f-xsmall.btn-fixed-width.max-at-tweak(type="button" @click.prevent="hideModal") Close
  
</template>

<script>
  import { mapActions } from 'vuex';
  import SectionTitle from "./SectionTitle";
  export default {
    name: "PhotoInstructionsModal",
    components: {
      SectionTitle
    },

    data() {
      return {
        instructions: [
          "Opt for a neutral background if possible",
          "Snap your photo in a well-lit room—better yet, head outside",
          "If you have Portrait mode, use it",
          "Be sure the photo is in focus",
          "Avoid using filters",
          "Make sure your roots are visible",
          "If possible, show mid-lengths and ends too"
        ]
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal'])
    }
  }
</script>

<style scoped lang="stylus">
  .photo-instructions
    .instruction-list
      list-style-type disc
      margin 2em auto
      max-width 35em
      padding-left 2em

    .examples
      margin-bottom 2em

      > *
        margin-bottom 1em

      .dos
      .donts
        > *
          padding 0 0.5em

        p
          margin 1em

    .footer
      margin 2em 0 1em

</style>
